var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-689.000000, -264.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(689.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E49437"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(27.208719, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3306878,
    cy: 18.7492958,
    rx: 18.2425595,
    ry: 18.7492958
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.1458333,
    cy: 32.9014085,
    rx: 31.1458333,
    ry: 31.0985915
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.541667, 18.028169)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9616965,2.27686698 C14.7843015,0.922748775 16.2475872,0.100156495 17.8253859,0.100156495 C19.4031845,0.100156495 20.8664703,0.922748775 21.6890752,2.27686698 L34.4455106,23.5408079 C35.2475346,24.927624 35.2523233,26.6352235 34.4580895,28.0265022 C33.6638559,29.4177811 32.1898932,30.2837708 30.5695989,30.301462 L5.06463626,30.301462 C3.46087866,30.2837708 1.98691585,29.4177811 1.19268223,28.0265022 C0.398448614,26.6352235 0.40323716,24.927624 1.21748352,23.5200595 L13.9616965,2.27686698 Z M3.81125129,25.0433368 C3.54390992,25.5056089 3.54231373,26.0748087 3.80705827,26.5385683 C4.0718028,27.0023279 4.56312376,27.2909912 5.08117294,27.2968579 L30.5530622,27.2968579 C31.0876481,27.2909912 31.5789691,27.0023279 31.8437135,26.5385683 C32.1084581,26.0748087 32.1068619,25.5056089 31.8517428,25.0640852 L19.1118442,3.82803931 C18.8390807,3.37904876 18.3513188,3.10485133 17.8253859,3.10485133 C17.3006062,3.10485133 16.8138302,3.37784769 16.5407248,3.8250885 L3.81125129,25.0433368 Z M16.3207563,11.0714151 C16.3207563,10.0757468 16.9944019,9.26859818 17.8253859,9.26859818 C18.6563699,9.26859818 19.3300156,10.0757468 19.3300156,11.0714151 L19.3300156,18.2826827 C19.3300156,19.2783511 18.6563699,20.0854996 17.8253859,20.0854996 C16.9944019,20.0854996 16.3207563,19.2783511 16.3207563,18.2826827 L16.3207563,11.0714151 Z M16.7614521,24.1984703 C16.1738577,23.6117672 16.1738577,22.6605333 16.7614521,22.0738302 C17.3490465,21.487127 18.3017253,21.487127 18.8893197,22.0738302 C19.4769142,22.6605333 19.4769142,23.6117672 18.8893197,24.1984703 C18.3017253,24.7851734 17.3490465,24.7851734 16.7614521,24.1984703 Z",
    id: "path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.52c5046917b7e4c37486b71e39c148d0.svg";
export { ForwardRef as ReactComponent };